// src/composables/useDigioPopup.js
import { DIGIO_ENV, DIGIO_BRAND } from "@/config/digio";

export function useDigioPopup() {
  function assertSdkLoaded() {
    if (!window.Digio) {
      throw new Error("Digio SDK not loaded. Ensure https://app.digio.in/sdk/v11/digio.js is present.");
    }
  }

  function start({ requestId, identifier, tokenId, onCallback }) {
    assertSdkLoaded();

    // Convert logo path to full URL if it's a relative path
    const logoUrl = DIGIO_BRAND.logo.startsWith('http')
      ? DIGIO_BRAND.logo
      : window.location.origin + DIGIO_BRAND.logo;

    // ✅ Digio published pattern: options + new Digio(options)
    var options = {
      environment: DIGIO_ENV, // "sandbox" | "production"
      callback: function (response) {
        console.log('[Digio Callback]', response);
        if (typeof onCallback === "function") onCallback(response);
      },
      logo: logoUrl,
      theme: {
        primaryColor: DIGIO_BRAND.theme.primaryColor,
        secondaryColor: DIGIO_BRAND.theme.secondaryColor
      }
    };

    console.log('[Digio Options]', options);

    try {
      var digio = new window.Digio(options);

      // ✅ Digio published pattern: init() must be called inside user click flow (popup blockers)
      digio.init();

      // ✅ TOKEN approach: submit(requestId, identifier, tokenId) from Create Request response (KID/GWT)
      digio.submit(requestId, identifier, tokenId);

      // Monitor for CSP/Network errors
      window.addEventListener('securitypolicyviolation', (e) => {
        console.error('CSP Violation detected:', e);
        if (e.blockedURI.includes('digilocker') || e.blockedURI.includes('digio')) {
          const errorResponse = {
            error_code: 'CSP_VIOLATION',
            message: 'Content Security Policy blocked DigiLocker. Please try from a different network or contact support.',
            blockedURI: e.blockedURI
          };
          if (typeof onCallback === "function") onCallback(errorResponse);
        }
      });

      return digio;
    } catch (error) {
      console.error('Digio initialization error:', error);
      throw new Error(`Failed to initialize Digio: ${error.message}`);
    }
  }  function cancel(digioInstance) {
    if (digioInstance && typeof digioInstance.cancel === "function") {
      digioInstance.cancel();
    }
  }

  return { start, cancel };
}
